module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_6005.995ec14b.png";